import { render, staticRenderFns } from "./form-input.vue?vue&type=template&id=0268dad6&scoped=true"
import script from "./form-input.vue?vue&type=script&lang=js"
export * from "./form-input.vue?vue&type=script&lang=js"
import style0 from "./form-input.vue?vue&type=style&index=0&id=0268dad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0268dad6",
  null
  
)

export default component.exports